import { categoryHelper } from '~/lib/category/helper';

export const useCategoryAncestorsLinks = (
  pAncestors: CategorySchema[] | Ref<CategorySchema[]>,
  section: string,
  content: UserContent | Ref<UserContent>
): Links => {
  const ancestors = toValue(pAncestors);

  let reversedAncestors = [...ancestors].reverse();

  if (section === Sections.ChildForYou) {
    // is an eval
    const chapterAncestorIndex = reversedAncestors.findIndex(
      (cat) => cat.contentType === ContentTypes.Chapter
    );
    reversedAncestors = reversedAncestors.slice(chapterAncestorIndex);
  }

  const profile = useProfileStore();

  const route = useRoute();

  const _reformatAncestor = (ancestor) => {
    const parent = { ...toValue(ancestor) };

    if (!(parent.quizzes || parent.posts || parent.exercises)) {
      // not populated
      const quizzes = [];
      const posts = [];
      const cats = [];
      const exercises = [];
      if (!parent.children) parent.children = [];
      parent.children.forEach((child) => {
        switch (child.type) {
          case 'quiz':
            quizzes.push(child);
            break;
          case 'post':
            posts.push(child);
            break;
          case 'exercise':
            posts.push(child);
            break;
          default:
            cats.push(child);
        }
      });
      parent.children = cats;
      parent.posts = posts;
      parent.quizzes = quizzes;
      parent.exercises = exercises;
      parent.essentialsArray = parent.essentialsArray
        ? parent.essentialsArray
        : [];
      parent.annalsArray = parent.annalsArray ? parent.annalsArray : [];
    }

    return parent;
  };

  const helper = categoryHelper();

  const isCategoryHidden = (category) => {
    if (helper.hasOnlyACategory(category)) {
      return true;
    }
    if (helper.hasOnlyAPost(category)) {
      return true;
    }
    if (helper.hasOnlyAnExercise(category)) {
      return true;
    }
    return false;
  };

  const getLinks = (categories) => {
    const items: Links = [];
    const { slug, memberName, name, memberId } = toValue(content);

    if (section === Sections.ChildForYou) {
      items.push({
        id: 'pour-toi',
        label: 'Pour toi',
        url: `/${section}`,
      });

      if (route.params.lb_or_eval) {
        items.push({
          id: 'ton-eval',
          label: 'Ton éval',
          url: `/${section}/${route.params.lb_or_eval as string}`,
        });
      }
    }

    categories.forEach((cat, index) => {
      const hidden = isCategoryHidden(cat);

      if (!hidden) {
        let url = `/${section}/${slug}/${cat.slug}`;

        let label = cat.title;

        if (index > 0) {
          switch (cat.contentType) {
            case ContentTypes.SubDiscipline:
            case ContentTypes.DisciplineSubSection:
              url = `/${section}/${slug}/${categories[index - 1].slug}#${
                cat.slug
              }`;
              break;
            case ContentTypes.InterDiscipline:
              try {
                url = `/${section}/${slug}/${categories[index - 2].slug}#${
                  cat.slug
                }`;
              } catch (e) {
                url = `/${section}/${slug}/#${cat.slug}`;
              }
              break;
          }
        } else if (section === Sections.InTheNews) {
          // TODO fix catr.displayHome
          url = '/';
          label = 'Accueil';
        } else if (section !== Sections.ChildForYou) {
          url = `/${section}/${slug}`;
          if (memberId && memberName && profile.isParent) {
            label = `${memberName} ( ${name} )`;
          } else {
            label = name;
          }
        }
        items.push({
          id: cat.id,
          label,
          url,
        });
      }
    });
    return items;
  };

  const categories = reversedAncestors.map((ancestor) =>
    _reformatAncestor(ancestor)
  );

  const links = getLinks(categories);

  return links;
};
